module.exports = __webpack_public_path__ + "static/media/filled_bar_preinspect.5e388ff8.svg";